import { Select } from 'antd';
import { ArrowSelect } from '../ArrowSelect/ArrowSelect';
import { SessionYearMonthSelectWrapper } from './SessionYearMonthSelectStyled';
import {
  DEFAULT_MAX_YEARS,
  TSessionYearMonthItem,
  buildMonthOptions,
  buildYearOptions,
  parseYearMonth,
  resolveYearMonthChange,
} from './sessionYearMonthUtil';

type TSessionYearMonthSelectProps = {
  sessions: TSessionYearMonthItem[];
  value?: string;
  onChange?: (value: string) => void;
  maxYears?: number;
  disabled?: boolean;
  size?: 'large' | 'middle' | 'small';
};

// Chọn 年月 (kỳ kiểm kê) tách thành 2 dropdown Năm/Tháng, value hợp nhất vẫn là "YYYYMM"
// để tương thích API/deep-link hiện có. Dùng chung cho các màn có dropdown kỳ kiểm kê.
function SessionYearMonthSelect({
  sessions,
  value,
  onChange,
  maxYears = DEFAULT_MAX_YEARS,
  disabled,
  size = 'large',
}: TSessionYearMonthSelectProps) {
  const { year, month } = parseYearMonth(value);
  const yearOptions = buildYearOptions(sessions, maxYears);
  const monthOptions = buildMonthOptions(sessions, year);

  const handleChangeYear = (nextYear: string) => {
    onChange?.(resolveYearMonthChange(sessions, nextYear, month));
  };

  const handleChangeMonth = (nextMonth: string) => {
    if (!year) {
      return;
    }
    onChange?.(`${year}${nextMonth}`);
  };

  return (
    <SessionYearMonthSelectWrapper className="session-year-month-select">
      <Select
        size={size}
        value={year}
        options={yearOptions}
        disabled={disabled}
        onChange={handleChangeYear}
        suffixIcon={<ArrowSelect />}
        className="session-year-month-select_year"
      />
      <Select
        size={size}
        value={month}
        options={monthOptions}
        disabled={disabled || !year}
        onChange={handleChangeMonth}
        suffixIcon={<ArrowSelect />}
        className="session-year-month-select_month"
      />
    </SessionYearMonthSelectWrapper>
  );
}

export { SessionYearMonthSelect };
